import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { updatePageTitle } from './utilityFunctions';

export const usePageTitle = () => {
  const location = useLocation();

  useEffect(() => {
    updatePageTitle(location.pathname);
  }, [location]);
};
